export default __webpack_public_path__ + "static/dashboard-b5972cb327662283c0f8680f925f3d77.svg";